import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_SESSION_LEVEL_OFFERS,
  GET_SESSION_LEVEL_OFFER,
  CREATE_SESSION_LEVEL_OFFER,
  UPDATE_SESSION_LEVEL_OFFER,
  DELETE_SESSION_LEVEL_OFFER,
} from 'actions/sessionLevelOffer';

function* fetchSessionLevelOffers(action) {
  try {
    const response = yield call(API.getSessionLevelOffers, action.payload);
    yield put({ type: FETCH_SESSION_LEVEL_OFFERS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_SESSION_LEVEL_OFFERS.FAIL, payload: { error: e } });
  }
}

function* getSessionLevelOffer(action) {
  try {
    const response = yield call(API.getSessionLevelOfferById, action.payload);
    yield put({ type: GET_SESSION_LEVEL_OFFER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GET_SESSION_LEVEL_OFFER.FAIL, payload: { error: e } });
  }
}

function* createSessionLevelOffer(action) {
  try {
    const response = yield call(API.addSessionLevelOffer, action.payload);
    yield put({ type: CREATE_SESSION_LEVEL_OFFER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_SESSION_LEVEL_OFFER.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* updateSessionLevelOffer(action) {
  try {
    const response = yield call(API.updateSessionLevelOffer, action.payload);
    yield put({ type: UPDATE_SESSION_LEVEL_OFFER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_SESSION_LEVEL_OFFER.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* deleteSessionLevelOffer(action) {
  try {
    const response = yield call(API.deleteSessionLevelOffer, action.payload);
    yield put({ type: DELETE_SESSION_LEVEL_OFFER.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_SESSION_LEVEL_OFFER.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* sessionLevelOffer() {
  yield takeLatest(FETCH_SESSION_LEVEL_OFFERS.REQUEST, fetchSessionLevelOffers);
  yield takeLatest(GET_SESSION_LEVEL_OFFER.REQUEST, getSessionLevelOffer);
  yield takeLatest(CREATE_SESSION_LEVEL_OFFER.REQUEST, createSessionLevelOffer);
  yield takeLatest(UPDATE_SESSION_LEVEL_OFFER.REQUEST, updateSessionLevelOffer);
  yield takeLatest(DELETE_SESSION_LEVEL_OFFER.REQUEST, deleteSessionLevelOffer);
}

export default sessionLevelOffer;
